export enum SwapStatus {
  not_started = 0,
  in_progess = 1,
  complete = 2,
  failed = 3,
  rejected = 4,
  approval_pending = 5,
  confirm_pending = 6
}